export default __webpack_public_path__ + "static/media/recorte_27.52e44e50.png";